const state = () => ({
    modal: null,
});

const mutations = {
    setModal(state, name) {
        state.modal = name;
    },
};

export default {
    namespaced: true,
    mutations,
    state,
};
